/**
 * 用户信息相关接口
 */

import { post, ApiResponse } from './api';
import { API_PATHS } from './apiPaths';

/**
 * 获取用户会员信息
 */
export async function getUserVIPInfo(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.UserVIPInfo, body, { params, originReturn: true });
}

/**
 * 获取用户信息
 */
export async function getUserInfo(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.GetUserInfo, body, { params });
}

/**
 * 提交用户年龄信息
 */
export async function writeUserInfo(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.UserInfoWrite, body, { params });
}

/**
 * 年龄授权确认
 */
export async function setUserGrant(body?: any, params?: any): Promise<ApiResponse<any>> {
  return post(API_PATHS.SetUserGrant, body, { params });
}
